// „In Mandant anmelden" und „Impersonieren" (docs/11 15c): Die Plattform
// signiert einen Ausweis, die Instanz öffnet sich damit in einem neuen Tab.

import { post } from "../../api/client";
import { errorText } from "../../lib/labels";
import { openPending } from "../../lib/window";
import { toast } from "../../ui/toaster";

/**
 * **Das Fenster geht vor dem `await` auf** (`openPending`) — nach einem
 * `await` blockiert der Browser es als Popup. Deshalb muss diese Funktion
 * direkt aus dem Klick-Handler gerufen werden, synchron bis zum ersten
 * `await`.
 */
export async function loginAs(tenantId: number, purpose: "admin" | "impersonate", targetEmail?: string): Promise<void> {
  const win = openPending();
  try {
    const res = await post<{ url: string }>(`/tenants/${tenantId}/login`, { purpose, target_email: targetEmail });
    win.go(res.url);
  } catch (err) {
    win.close();
    toast(errorText(err), "error");
  }
}
